import request from './request';
import { AdobePass } from 'enums';
const { Env: AdobePassEnv } = AdobePass;

export const REQUESTOR_ID = 'ESPN';

const ENVIRONMENT_CONFIGURATION = {
    [AdobePassEnv.STAGING]: {
        baseUrl: 'https://api.auth-staging.adobe.com'
    },
    [AdobePassEnv.PROD]: {
        baseUrl: 'https://api.auth.adobe.com'
    }
};

export const SERVICE_PATH = {
    reggie: '/reggie/v1',
    sp: '/api/v1'
};

export const ENDPOINTS = {
    config: '/config',
    checkRegCode: '/regcode',
    checkAuthN: '/checkauthn',
    authenticate: '/authenticate'
};

function getBaseUrl(env = AdobePassEnv.PROD) {
    // In the event the query parameter `passenv` value does not match the ENVIRONMENT_CONFIGURATION
    // object, we want to default to the `production` baseUrl
    const defaultEnv = AdobePassEnv.PROD;
    return ENVIRONMENT_CONFIGURATION[env].baseUrl || ENVIRONMENT_CONFIGURATION[defaultEnv].baseUrl;
}

export function getSpUrl(env) {
    return `${getBaseUrl(env)}${SERVICE_PATH.sp}`;
}

export function getReggieUrl(env) {
    return `${getBaseUrl(env)}${SERVICE_PATH.reggie}`;
}

export function getConfig() {
    const url = `${getSpUrl()}${ENDPOINTS.config}/${REQUESTOR_ID}`;
    return request
        .get(url)
        .set('Accept', 'application/json')
        .then(({body}) => body)
        .catch(err => err);
}

export function checkRegCode(regCode, env) {
    const url = `${getReggieUrl(env)}/${REQUESTOR_ID}${ENDPOINTS.checkRegCode}/${regCode}`;
    return request
        .get(url)
        .set('Accept', 'application/json')
        .then(({body}) => body)
        .catch(err => err);
}

// Not currently used although recommended by Adobe to call before success page
// http://tve.helpdocsonline.com/clientless-api-reference$$check_authn_token
export function checkAuthN(regCode) {
    const url = `${getSpUrl()}${ENDPOINTS.checkAuthN}/${regCode}?requestor=${REQUESTOR_ID}`;
    return request
        .get(url)
        .set('Accept', 'application/json')
        .then(({status}) => status === 200)
        .catch(() => false);
}

export function getAuthSuccessUrl({mvpd, deviceType, baseUrl = window.location.href}) {
    return `${baseUrl}${baseUrl.indexOf('?') === -1 ? '?' : '&'}mvpd=${mvpd}&authSystem=adobepass&deviceType=${deviceType}&authSuccess=true`;
}

export function getAuthErrorUrl({baseUrl = window.location.href}) {
    return `${baseUrl}${baseUrl.indexOf('?') === -1 ? '?' : '&'}error=true`;
}

export function getAuthenticateUrl({regCode, mvpd, deviceType, baseUrl = window.location.href, adobePassEnv }) {
    const redirectUrl = getAuthSuccessUrl({mvpd, deviceType, baseUrl});
    const qs = `reg_code=${regCode}&noflash=true&mso_id=${mvpd}&requestor_id=${REQUESTOR_ID}&domain_name=adobe.com&redirect_url=${encodeURIComponent(redirectUrl)}`;
    const url = `${getSpUrl(adobePassEnv)}${ENDPOINTS.authenticate}?${qs}`;

    return url;
}



// WEBPACK FOOTER //
// ./app/lib/api/AdobeClientlessAPI.js